<template>
    <vertical-form-table v-model="form" v-bind="{ items }" @input="emit">
        <template #연락처>
            <v-row align="center">
                <v-col> <v-phone-field v-model="form.recruiter.phone" outlined @input="emit" /> </v-col>
                <v-col cols="12" md="auto"> <v-checkbox v-model="form.recruiter.hidesPhone" label="비노출" dense inset hide-details @input="emit" /> </v-col>
            </v-row>
        </template>
        <template #이메일>
            <v-row align="center">
                <v-col> <v-email-field v-model="form.recruiter.email" outlined @input="emit" /> </v-col>
                <v-col cols="12" md="auto"> <v-checkbox v-model="form.recruiter.hidesEmail" label="비노출" dense inset hide-details @input="emit" /> </v-col>
            </v-row>
        </template>
    </vertical-form-table>
</template>

<script>
import { initRecruitment } from "@/assets/variables";

import VPhoneField from "@/components/dumb/v-phone-field.vue";
import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";
import VEmailField from "@/components/dumb/v-email-field.vue";

export default {
    components: {
        VPhoneField,
        VerticalFormTable,
        VEmailField,
    },
    props: {
        value: { type: Object, default: initRecruitment },
    },
    data: () => ({
        form: initRecruitment(),
    }),
    computed: {
        items() {
            return [
                {
                    key: "recruiter.name",
                    term: "이름",
                    type: "text",
                },
                {
                    term: "연락처",
                },
                {
                    term: "이메일",
                },
            ].map((item) => ({ ...item, outlined: true }));
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initRecruitment(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
};
</script>

<style>
</style>